import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { equals, isEmpty } from 'ramda'
import moment from 'moment'
import { replace } from 'react-router-redux'
import ProfilePanel from '../../Components/ProfilePanel'
import ProfilePageContent from './ProfilePageContent'
import ParentProfile from './ParentProfile'
import ModalBottom from '../../Components/ModalBottom'
import GoToButton from '../../Components/CustomButtons/GoToButton'
import LoadingSpinner from '../../Components/LoadingSpinner'
import ModalContainer from '../../Components/ModalContainer'
import CheckInModal from '../../Components/ModalContainer/CheckInModal'
import ModalAssessment from '../../Components/ModalContainer/ModalAssessment'
import DeleteStudentModal from '../../Components/ProfileViews/DeleteStudentModal'
import DeleteActivityModal from '../../Components/ProfileViews/DeleteActivityModal'
import StudyProgramsActions from '../../Data/Redux/StudyProgramsRedux'
import ActivityInProgressWarning from './ActivityInProgressWarning'
import GroupModal from '../../Components/ModalContainer/GroupModal'
import CompaniesActions from '../../Data/Redux/CompaniesRedux'
import ClassroomActions, { Selectors } from '../../Data/Redux/ClassroomRedux'
import AllCentersActions from '../../Data/Redux/AllCentersRedux'
import ReminderActions from '../../Data/Redux/PaymentRemindersRedux'
import ActivityActions from '../../Data/Redux/ActivityRedux'
import DisenrollmentCategoriesActions from '../../Data/Redux/DisenrollmentCategoriesRedux'
import { notificationFail } from '../../Data/Redux/NotificationActions'
import CenterProductsActions from '../../Data/Redux/CenterProductsRedux'
import HealthCheckActions from '../../Data/Redux/HealthCheckRedux'
import InventoryActions from '../../Data/Redux/InventoryRedux'

import { isTeacher } from '../../utils/Utils'

const Container = styled.div`
  width: 100%;
  min-height: 80vh;
`
const PageContainer = styled.div`
  min-height: 80vh;
  padding-top: 32px;
  padding-left: 24px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  @media (max-width:767px) {
    width: 100%;
    padding: 0;
    flex-direction: column;
  }
`
const ModalContent = styled.div`
  padding: 8px;
`

const LoadingContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`

const PendingPaymentsBar = styled.div`
  background: #4A90E2;
  width: 100%;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  color:white;
  font-size: 12px;
  @media (max-width:767px) {
    display: none;
  }
  div {
    text-decoration: underline;
    cursor: pointer;
    margin-left: 4px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  img, div img {
    margin-right: 4px;
    margin-left: 4px;
  }
`

const VIEWS = {
  Profile: ProfilePageContent,
  Parent: ParentProfile,
}

class StudentProfile extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeChild: {},
      view: 'Profile',
      activeParent: null,
      open: false,
      isActivityModalOpen: false,
      checkInOpen: false,
      healthCheckOpen: false,
      incidentModalOpen: false,
      isIncident: false,
      deleteOpen: false,
      activityInProgressWarning: false,
      warningType: '',
      activityId: 0,
      deleteActivityModal: false,
      isValid: false,
    }
  }

  componentWillMount() {
    this.loadStudentInfo(this.props)
    this.setState({ isValid: false })
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.classrooms.length > 0) {
          const { activeStudentId, activeClassroomId, studentProfile, isCheckedOut, parent } = nextProps

      if (!equals(this.props.studentProfile, studentProfile)) {
        const firstTimeAccess = this.props.studentProfile.birth_date
        if (!firstTimeAccess) {
          /* solo en caso que se entre directamente a la pantalla
          y no tenga ni activeStudentId ni activeClassroomId */
          if (!nextProps.parent && nextProps.parent !== undefined) {
            this.props.getStudentProfile(activeStudentId, activeClassroomId, '', isCheckedOut)
          } else if (nextProps.parent !== undefined) {
            if (Object.keys(nextProps.parent).length === 0) {
              this.props.getStudentProfile(activeStudentId, activeClassroomId, '', isCheckedOut)
            }
          }
        }
      }

      if (nextProps.newActivity && nextProps.newActivity !== this.props.newActivity) {
        this.props.getStudentProfile(activeStudentId, activeClassroomId, '', isCheckedOut)
      }
    }

    if (nextProps.activeClassroomId !== this.props.activeClassroomId) {
      // ya habian entrado
      if(nextProps.user.role !== 'Back Office Admin'){
         this.props.newUrl(`/classroom/${nextProps.activeClassroomId}/student/${nextProps.activeStudentId}`)
       }
    }
    if (!isEmpty(nextProps.studentProfile)) {
      if (nextProps.studentProfile.latest_activities &&
        nextProps.studentProfile.latest_activities.length > 0) {
        this.setState({ isValid: true })
      }
    }

    if (nextProps.activeStudentId !== this.props.activeStudentId && this.props.activeStudentId !== 0) {
      this.setState({
        activeChild: {},
        view: 'Profile',
        activeParent: null,
        open: false,
        isActivityModalOpen: false,
        checkInOpen: false,
        healthCheckOpen: false,
        report: false,
        deleteOpen: false,
        activityInProgressWarning: false,
        warningType: '',
        activityId: 0,
        deleteActivityModal: false,
        isValid: false,
      }, () => this.loadStudentInfo(nextProps, true))
    }
  }

  componentWillUnmount() {
   if(this.props.user.user_type === 'Back Office'){
    this.props.getCenterStudyRrogramReset()
    this.props.getCenterProductsError()
    this.props.setUserCenterid(0);
   }
   this.props.getStudentProfileErrorReset()
  }

  onHealthCheckClick = () => {
    this.setState({ healthCheckOpen: !this.state.healthCheckOpen })
  }

  onNewActivityClick = () => {
    this.props.getPhotoCatalogue()
    this.setState({ isActivityModalOpen: !this.state.isActivityModalOpen, isIncident: false })
  }

  onReportClick = () => {
    this.props.getPhotoCatalogue()
    this.setState({ isActivityModalOpen: !this.state.isActivityModalOpen, isIncident: true })
  }

  onCheckInClick = () => {
    this.setState({ checkInOpen: !this.state.checkInOpen, checkType: 'checkin', open: false })
  }

  onCheckOutClick = () => {
    this.setState({ checkInOpen: !this.state.checkInOpen, checkType: 'checkout' })
  }

  loadStudentInfo(props, updated = false) {
    if (!updated) {
      this.props.getActivityCategories()
      this.props.getDisenrollmentCategories()
        if(props.user.role !== 'Back Office Admin') {
          this.props.getCenterProducts(props.user.center_id);
        }
    }

    if (updated === true) {
      // Ha cambiado el studentId
      const { id, classId } = props.match.params
      this.props.getStudentProfile(Number(id), Number(classId), '')

      this.props.setActiveStudentId(Number(id))
      this.props.setActiveClassroomId(Number(classId))
    } else if (props.activeStudentId === 0 && props.activeClassroomId === 0) {
      // Entraron directamente a la ruta de la pantalla
      const { id, classId } = props.match.params
      if(props.user.role  === 'Back Office Admin'){
        this.props.getCenter(classId);
      }
      this.props.setActiveStudentId(Number(id))
      this.props.setActiveClassroomId(Number(classId))

      // Entraron desde center
    } else if (props.classrooms.length > 0) {
      const { activeStudentId, activeClassroomId } = props
      // // Ya habian entrado anteriormente
      // if (props.studentProfile.birth_date) {
      //   if (props.user.role !=='Back Office Admin'){
      //     this.props.getStudentProfile(
      //       activeStudentId, activeClassroomId, '')
      //     }else if (props.user.role ==='Back Office Admin'){
      //       this.props.getStudentProfile(activeStudentId, activeClassroomId, '')
      //     }
      // } else {
        // // Entraron por primera vez
        // if(props.user.role !== 'Back Office Admin'){
          this.props.getStudentProfile(activeStudentId, activeClassroomId, '')
        // }
      // }
    }
  }

  closeActivity = () => this.setState({ isActivityModalOpen: false, report: false })

  handleParentClick = (e) => {
    this.props.setActiveParentId(Number(e.currentTarget.id))
    this.setState({ view: 'Parent' })
  }

  handleBackClick = () => {
    this.setState({ view: 'Profile' })
  }

  handleMoreActionsClick = () => {
    this.setState({ open: !this.state.open })
  }

  sendReminder = () => {
    const { id } = this.props.match.params
    this.props.sendReminder(Number(id))
  }

  toggleDeleteModal = () => {
    const {  studentProfile } = this.props
    if (studentProfile.latest_activities.length > 0) {
      if (!studentProfile.latest_activities[0].finished_at) {
        this.setState({ activityInProgressWarning: !this.state.activityInProgressWarning, warningType: 'disenroll' })
      } else {
        this.setState({ deleteOpen: !this.state.deleteOpen })
      }
    } else {
      this.setState({ deleteOpen: !this.state.deleteOpen })
    }
  }

  closeDeleteModal = () => {
    this.setState({ deleteOpen: false })
  }

  closeActivityWarning = () => {
    this.setState({ activityInProgressWarning: false })
  }

  continueToFinishActivity = () => {
    this.setState({
      activityInProgressWarning: false,
      isActivityModalOpen: !this.state.isActivityModalOpen,
      isIncident: false,
    })
  }

  handleDeleteStudent = (data) => {
    const {  activeStudentId } = this.props
    // this.toggleDeleteModal()
    this.props.deleteStudent(activeStudentId, data)
  }

  restoreStudent = () => {
    const {  activeStudentId } = this.props
    this.props.restoreStudent(activeStudentId)
  }

  handleEnroll = () => {
    this.setState({ activityInProgressWarning: !this.state.activityInProgressWarning, warningType: 'enroll' })
  }

  closeGroupModal = () => {
    this.props.closeActivity()
    this.setState({ tab: 'all' })
  }

  toggleDeleteActivity = (activityId) => {
    const { deleteActivityModal } = this.state
    this.setState({ deleteActivityModal: !deleteActivityModal, activityId })
  }

  handleCloseDeleteActivity = () => {
    this.setState({ deleteActivityModal: false })
  }

  deleteActivity = () => {
    const { activityId } = this.state
    this.props.deleteActivity(activityId)
  }

  render() {
    const CurrentView = VIEWS[this.state.view]
    const {
      studentProfile,
      disenrollmentCategories,
      sending,
      sendingCheckin,
      sendingHealthcheck,
      activityLoading,
      deletingActivity,
      relations,
      anyLoading,
      loading,
      studentHomeReport,
    } = this.props
    const { deleteActivityModal, isValid } = this.state
    return (
      <Container>
        {studentProfile.deleted_at && (<PendingPaymentsBar >
          <img src="/assets/Warning.svg" alt="warning" />
          <span>Este alumno esta dado de baja </span>
          <div onClick={this.handleEnroll}> {/* eslint-disable-line*/}
            Dar de alta
            <img src="/assets/white_next_arrow.svg" alt="go" />
          </div>
        </PendingPaymentsBar>)}
        {studentProfile.pending_payment && (<PendingPaymentsBar >
          <img src="/assets/Warning.svg" alt="warning" />
          <span>Este alumno tiene un saldo pendiente. </span>
          <div onClick={this.sendReminder} > {/* eslint-disable-line*/}
            Enviar recordatorio de pago
            <img src="/assets/white_next_arrow.svg" alt="go" />
          </div>
        </PendingPaymentsBar>)}
        {(studentProfile.status_id === 2 || studentProfile.status_id === 4) && (<PendingPaymentsBar >
          <img src="/assets/Warning.svg" alt="warning" />
          <span>Este alumno aun no esta activo. </span>
          {/* <div onClick={this.handleEnroll}>
            Dar de alta
            <img src="/assets/white_next_arrow.svg" alt="go" />
          </div> */}
        </PendingPaymentsBar>)}
        <PageContainer>
          <ProfilePanel
            student={this.props.studentProfile}
            userRole="principal"
            onParentClick={this.handleParentClick}
            onMoreActionsClick={this.handleMoreActionsClick}
            onNewActivityClick={this.onNewActivityClick}
            onCheckIn={this.onCheckInClick}
            onCheckOut={this.onCheckOutClick}
            onHealthCheck={this.onHealthCheckClick}
            onReportClick={this.onReportClick}
            user={this.props.user}
            teacher={isTeacher(this.props.user.role)}
            classrooms={this.props.classrooms}
            studyPrograms={this.props.studyPrograms}
            isDisenrolled={studentProfile.deleted_at}
            relations={relations}
            />
        {!loading ?
            <CurrentView
              student={this.props.studentProfile}
              loading={this.props.loading}
              onBack={this.handleBackClick}
              onNewActivityClick={this.onNewActivityClick}
              activityCategories={this.props.activityCategories}
              onDeleteActivity={this.toggleDeleteActivity}
              categories={this.props.activityCategories}
              onCheckIn={this.onCheckInClick}
              onCheckOut={this.onCheckOutClick}
              user={this.props.user}
              studyPrograms={this.props.studyPrograms}
              onDeleteStudent={this.toggleDeleteModal}
              isDisenrolled={studentProfile.deleted_at? true:false}
              centerProducts={this.props.center_products}
              onHealthCheck={this.onHealthCheckClick}
              sendingActivity={activityLoading}
              anyLoading={anyLoading}
            />
            :
            <LoadingContainer>
              <LoadingSpinner />
            </LoadingContainer>
          }
        </PageContainer>
        {/* Modal para formato de entrada en Movil */}
        <ModalBottom
          open={this.state.open}
          onClose={this.handleMoreActionsClick}
        >
          <ModalContent>
            <GoToButton
              icon="/assets/greenCheckIn.svg"
              label="Formato de entrada"
              onButtonClick={this.onCheckInClick}
            />
          </ModalContent>
        </ModalBottom>
        <GroupModal
          open={this.props.activityResponse.openActivity}
          children={this.props.partners}
          closeModal={this.closeGroupModal}
          categories={this.props.activityCategories}
          user={this.props.user}
        />
        {/* Modal de Actividades */}
        <ModalContainer
          isOpen={this.state.isActivityModalOpen}
          child={this.props.studentProfile}
          children={this.props.partners}
          closeModal={this.closeActivity}
          isIncidentActivity={this.state.isIncident}
          postActivity={this.props.postActivity}
          postFinishActivity={this.props.postFinishActivity}
          categories={this.props.activityCategories}
          loading={activityLoading}
        />
        {/* Modal de Entrada Y Salida */}
        <CheckInModal
          open={this.state.checkInOpen}
          child={this.props.studentProfile}
          closeCheckIn={this.onCheckInClick}
          closeCheckOut={this.onCheckOutClick}
          consumables={this.props.inventory.Consumables}
          accessories={this.props.inventory.Accessories}
          postStudentCheckIn={this.props.postStudentCheckIn}
          postStudentCheckOut={this.props.postStudentCheckOut}
          isTeacher={this.props.user.role === 'Teacher'}
          type={this.state.checkType}
          studyPrograms={this.props.studyPrograms}
          loading={sendingCheckin}
        />
        {/* Modal de Valoracion Diaria */}
        <ModalAssessment
          open={this.state.healthCheckOpen}
          child={this.props.studentProfile}
          children={this.state.partners}
          closeAssessment={this.onHealthCheckClick}
          extra={this.props.healthCheck.Extra}
          revise={this.props.healthCheck.Revise}
          askParent={this.props.healthCheck["Ask Parent"]}
          postChildHealthCheck={this.props.postChildHealthCheck}
          fromProfile
          isTeacher={this.props.user.role === 'Teacher'}
          healthCheckResponse={this.props.healthCheckResponse}
          loading={sendingHealthcheck}
          studentHomeReport={studentHomeReport}
        />
        <ActivityInProgressWarning
          open={this.state.activityInProgressWarning}
          onClose={this.closeActivityWarning}
          disenroll={this.continueToFinishActivity}
          enroll={this.restoreStudent}
          type={this.state.warningType}
          loading={sending}
        />
        <DeleteStudentModal
          open={this.state.deleteOpen}
          onClose={this.closeDeleteModal}
          onDeleteStudent={this.handleDeleteStudent}
          disenrollmentCategories={disenrollmentCategories}
          loading={sending}
        />
        <DeleteActivityModal
          open={deleteActivityModal}
          onClose={this.handleCloseDeleteActivity}
          onDeleteActivity={this.deleteActivity}
          loading={deletingActivity}
        />
      </Container>
    )
  }
}

StudentProfile.propTypes = {
  studentProfile: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  activeStudentId: PropTypes.number.isRequired,
  activeClassroomId: PropTypes.number.isRequired,
  classrooms: PropTypes.array.isRequired,
  relations: PropTypes.array.isRequired,
  getClassrooms: PropTypes.func.isRequired,
  getCenter: PropTypes.func.isRequired,
  getCenterClassroom: PropTypes.func.isRequired,
  getCenterCompany: PropTypes.func.isRequired,
  getStudentProfile: PropTypes.func.isRequired,
  setActiveStudentId: PropTypes.func.isRequired,
  setActiveClassroomId: PropTypes.func.isRequired,
  setActiveParentId: PropTypes.func.isRequired,
  getStudentProfileErrorReset: PropTypes.func.isRequired,
  getCenterStudyRrogramReset: PropTypes.func.isRequired,
  sendReminder: PropTypes.func.isRequired,
  partners: PropTypes.array.isRequired,
  deleteActivity: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  studyPrograms: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]),
}

StudentProfile.defaultProps = {
  studyPrograms: [],
}

const mapStateToProps = state => ({
  anyLoading: state.classrooms.get.fetching ||
    state.healthCheck.get.fetching ||
    state.inventory.get.fetching ||
    state.activity.get.fetching ||
    state.study_programs.get.fetching ||
    state.disenrollment.get.fetching ||
    state.center_products.get.fetching ||
    state.relations.get.fetching,
  studentProfile: Selectors.activeStudent(state),
  classrooms: state.classrooms.get.results,
  loading: state.classrooms.get.fetching,
  activeStudentId: state.classrooms.activeStudentId,
  activeClassroomId: state.classrooms.activeClassroomId,
  activeParentId: state.classrooms.activeParentId,
  partners: Selectors.partners(state),
  healthCheck: state.healthCheck.get.results,
  healthCheckResponse: state.healthCheck.data,
  inventory: state.inventory.get.results,
  activityCategories: state.activity.get.results,
  activityLoading: state.activity.sending.fetching,
  activityResponse: state.activity,
  user: Selectors.activeUser(state , state.classrooms.center_id),
  studyPrograms: state.study_programs.get.results,
  disenrollmentCategories: state.disenrollment.get.results,
  isCheckedOut: state.classrooms.checkout,
  parent: Selectors.activeParent(state),
  center_products: state.center_products.get.results,
  sending: state.classrooms.sendRequest.fetching,
  sendingHealthcheck: state.healthCheck.sending.fetching,
  sendingCheckin: state.inventory.sending.fetching,
  deletingActivity: state.activity.delete_activity.fetching,
  relations: state.relations.get.results,
  newActivity: state.classrooms.newActivity,
  center_id: state.classrooms.center_id,
  studentHomeReport: state.home_report.student_home_report.result,
})


const mapDispatchToProps = dispatch => ({
  getAllCenters: () => dispatch(AllCentersActions.getRequest()),
  newUrl: path => dispatch(replace(path)),
  getCenterProducts: centerId => dispatch(CenterProductsActions.getRequest(centerId)),
  getCenterProductsError: () => dispatch(CenterProductsActions.getReset()),
  getClassrooms: () => dispatch(ClassroomActions.getRequest()),
  getCenter: classroomId => dispatch(ClassroomActions.getCenterRequest(classroomId)),
  getCenterClassroom: centerId => dispatch(ClassroomActions.getClassroomRequest(centerId)),
  getCenterCompany: centerId => dispatch(CompaniesActions.getCenterCompanyRequest(centerId)),
  getStudentProfile: (activeStudent, activeClassroom, timestamp, isCheckedOut) =>
    dispatch(ClassroomActions.getStudentProfileRequest(activeStudent, activeClassroom, timestamp, isCheckedOut)),
  setActiveStudentId: id => dispatch(ClassroomActions.setActiveStudentId(id)),
  setActiveClassroomId: id => dispatch(ClassroomActions.setActiveClassroomId(id)),
  setActiveParentId: id => dispatch(ClassroomActions.setActiveParentId(id)),
  setUserCenterid: id => dispatch(ClassroomActions.setUserCenterid(id)),
  getStudentProfileErrorReset: () => dispatch(ClassroomActions.getStudentProfileErrorReset()),
  getCenterStudyRrogramReset: () => dispatch(StudyProgramsActions.getReset()),
  postChildHealthCheck: (id, info, isTeacher, fromProfile) =>
    dispatch(HealthCheckActions.postHealthCheckRequest(id, info, isTeacher, fromProfile)),
  sendReminder: studentId => dispatch(ReminderActions.sendOneRequest(studentId)),
  postStudentCheckIn: (checkin_id, info) =>
    dispatch(InventoryActions.postCheckInRequest(checkin_id, info)),
  postStudentCheckOut: (checkin_id, info, isTeacher) =>
    dispatch(InventoryActions.postCheckOutRequest(checkin_id, info, isTeacher)),
  postActivity: (id, info) => dispatch(ActivityActions.postActivityRequest(id, info)),
  getPhotoCatalogue: () => dispatch(ActivityActions.getPhotoCatalogueRequest()),
  postFinishActivity: (id, info) => dispatch(ActivityActions.postFinishActivityRequest(id, info)),
  getActivityCategories: () => dispatch(ActivityActions.getRequest()),
  deleteActivity: activityId => dispatch(ActivityActions.deleteActivityRequest(activityId)),
  deleteStudent: (studentId, deleteInfo) =>
    dispatch(ClassroomActions.deleteStudentRequest(studentId, deleteInfo)),
  activityInProgress: msg => dispatch(notificationFail(msg)),
  restoreStudent: studentId => dispatch(ClassroomActions.restoreStudentRequest(studentId)),
  getDisenrollmentCategories: () => dispatch(DisenrollmentCategoriesActions.getRequest()),
  closeActivity: () => dispatch(ActivityActions.closeActivity()),
})
export default connect(mapStateToProps, mapDispatchToProps)(StudentProfile)



// WEBPACK FOOTER //
// ./src/Containers/StudentProfile/StudentProfile.jsx